module.exports = __webpack_public_path__ + "img/flag-CO.f025431a.svg";